import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
  Container,
  Card,
  CardContent,
  CardActions
} from '@mui/material';
import { Login as LoginIcon, Phone as PhoneIcon } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';

const LoginPage: React.FC = () => {
  const { login } = useAuth();

  return (
    <Container maxWidth="sm">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
      >
        <Paper elevation={6} sx={{ p: 4, width: '100%' }}>
          <Box textAlign="center" mb={4}>
            <PhoneIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
            <Typography variant="h3" component="h1" gutterBottom color="primary">
              📞 Telefonbuch
            </Typography>
            <Typography variant="h6" color="textSecondary">
              Sicherer Zugang erforderlich
            </Typography>
          </Box>

          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="body1" gutterBottom>
                Willkommen zum Telefonbuch-System. Bitte melden Sie sich mit Ihren 
                Authentik-Zugangsdaten an.
              </Typography>
              
              <Box sx={{ mt: 2 }}>
                <Typography variant="body2" color="textSecondary">
                  <strong>Verfügbare Rollen:</strong>
                </Typography>
                <Typography variant="body2" sx={{ ml: 2 }}>
                  • <strong>telefonbuch_viewer:</strong> Kontakte anzeigen und durchsuchen
                </Typography>
                <Typography variant="body2" sx={{ ml: 2 }}>
                  • <strong>telefonbuch_admin:</strong> Kontakte verwalten (hinzufügen, bearbeiten, löschen)
                </Typography>
              </Box>
            </CardContent>
            
            <CardActions sx={{ justifyContent: 'center', pb: 2 }}>
              <Button
                variant="contained"
                size="large"
                startIcon={<LoginIcon />}
                onClick={login}
                sx={{ px: 4, py: 1.5 }}
              >
                Mit Authentik anmelden
              </Button>
            </CardActions>
          </Card>

          <Box textAlign="center">
            <Typography variant="caption" color="textSecondary">
              Powered by Authentik Identity Provider
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default LoginPage;
